import React, { useRef, useEffect, useState } from "react";
//import visitingCardService from "../Services/Service";

import visitingCardService from "../Services/VisitingCardService";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  IconButton,
  Skeleton,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Tesseract from "tesseract.js";
import { motion } from "framer-motion";
import { Snackbar, Alert } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import cardService from "../Services/Service";

import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";

import { Autocomplete } from "@mui/material";

const gptApiUrl = "https://chatgptapi.iecsl.in/api/ChatBot/chat";



export default function BusinessCardScannerParsed() {
  const txtCompany = useRef(null);
  const txtAddress = useRef(null);
  const txtName = useRef(null);
  const txtDesignation = useRef(null);
  const txtContact = useRef(null);
  const txtEmail = useRef(null);
  const txtWebsite = useRef(null);

  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);
  const [frontOCR, setFrontOCR] = useState("");
  const [backOCR, setBackOCR] = useState("");
  const [loading, setLoading] = useState(false);
  const [parsedData, setParsedData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });
  const [fieldErrors, setFieldErrors] = useState({});

  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");

  const [openEvent, setOpenEvent] = useState(false);

  const [form, setForm] = useState({
    id: "0",
    name: "",
  });

  const [editing] = useState(false);

  // useEffect(() => {
  //   visitingCardService.setApiUrl(sessionStorage.getItem('APIUrl') + "/api/VisitingCard");
  //    fetchEvents();
  // }, []);

  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const userType = sessionStorage.getItem("UserType");

  console.log("Card Scan UserType:", userType);

  // useEffect(() => {
  //   fetchEvents();

  // }, []);

  useEffect(() => {
    fetchEvents();

    if (userType === "Private") {
      bindEmployees();
    }
  }, []);

  const loggedInEmpNo = sessionStorage.getItem("EmpNo");

  const empList = [...selectedEmployees.map((x) => x.empNo), loggedInEmpNo];
  const fetchEvents = async () => {
    try {
      const apiUrl = sessionStorage.getItem("APIUrl");

      cardService.setApiUrl(apiUrl + "/api/Event");

      const res = await cardService.getAll();

      setEvents(res.data || []);
    } catch (err) {
      //console.error(err);
    }
  };

  const bindEmployees = async () => {
    try {
      const apiUrl = sessionStorage.getItem("APIUrl");

      cardService.setApiUrl(apiUrl + "/api/UserMapping");

      const res = await cardService.loadUsername(0, "Employee");

      console.log("Employee API Response:", res);
      console.log("Employee Data:", res.data);

      setEmployeeList(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleBlur = () => {
    const value = form.name.trim();

    if (value) {
      setForm((prev) => ({
        ...prev,
        name: value,
      }));
    }
  };
  const handleEventSubmit = async (e) => {
    e.preventDefault();

    const eventName = form.name.trim();

    // Required validation
    if (!eventName) {
      setSnackbar({
        open: true,
        message: "Event Name is required",
        severity: "error",
      });
      return;
    }

    // Duplicate validation
    const duplicate = events.some(
      (r) => r.eventName?.trim().toLowerCase() === eventName.toLowerCase(),
    );

    if (duplicate) {
      setSnackbar({
        open: true,
        message: "Duplicate Event!",
        severity: "error",
      });
      return;
    }

    try {
      const response = await cardService.create({
        EventId: form.id,
        EventName: eventName,
        OpFlag: editing ? "Update" : "Insert",
        UserName: sessionStorage.getItem("userEmail"),
      });

      const message = response?.data?.message || "Event saved successfully";

      const vOutput = message.split(":");

      setSnackbar({
        open: true,
        message: vOutput[0],
        severity: vOutput[1] || "success",
      });

      setOpenEvent(false);

      setForm({
        id: "0",
        name: "",
      });

      await fetchEvents();

      const res = await cardService.getAll();

      setEvents(res.data);

      const newEvent = res.data.find(
        (x) => x.eventName?.trim().toLowerCase() === eventName.toLowerCase(),
      );

      if (newEvent) {
        setSelectedEvent(newEvent.eventId);
      }
    } catch (error) {
      console.error("Error saving event:", error);

      setSnackbar({
        open: true,
        message: "Error while saving event",
        severity: "error",
      });
    }
  };
  const handleClick = async (e) => {
    e.preventDefault();

    const company = txtCompany.current?.value?.trim() || "";
    const name = txtName.current?.value?.trim() || "";
    const contact = txtContact.current?.value?.trim() || "";
    const email = txtEmail.current?.value?.trim() || "";

    const newErrors = {};

    if (!company) {
      newErrors.company = "Company Name is required";
    }

    if (!name) {
      newErrors.name = "Name is required";
    }

    if (!contact) {
      newErrors.contact = "Contact No. is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    }

    setFieldErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const payload = {
      EventId: selectedEvent,
      Name: txtName.current.value,
      Designation: txtDesignation.current.value,
      Company_Name: txtCompany.current.value,
      Contact: txtContact.current.value,
      Email: txtEmail.current.value,
      Web_Site: txtWebsite.current.value,
      Address: txtAddress.current.value,

      // PrivateUsers: selectedEmployees.map(x => x.empNo).join(',')

      PrivateUsers: [...new Set(empList)].join(","),
      UserName: sessionStorage.getItem("userEmail") || "",
    };
    console.log(payload);

    //console.log("Sending Payload:", payload);

    try {
      const response = await visitingCardService.create(payload);

      //console.log("API Response:", response);

      setParsedData(null);
      clear();
      setFrontPreview(null);
      setFrontOCR("");
      setBackPreview(null);
      setBackOCR("");

      setSnackbar({
        open: true,
        message: "Card details saved successfully!",
        severity: "success",
      });
    } catch (error) {
      //console.error("API Error:", error);

      setSnackbar({
        open: true,
        message: "Error while saving card details",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const clear = () => {
    txtName.current.value = "";
    txtDesignation.current.value = "";
    txtCompany.current.value = "";
    txtContact.current.value = "";
    txtEmail.current.value = "";
    txtWebsite.current.value = "";
    txtAddress.current.value = "";
    txtName.current.focus();
  };

  // Rotate image
  const rotateImage = (imageUrl, angle) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (angle === 90 || angle === 270) {
          canvas.width = img.height;
          canvas.height = img.width;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((angle * Math.PI) / 180);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);

        resolve(canvas.toDataURL());
      };
    });
  };

  // OCR
  const runOCR = async (imageUrl) => {
    let bestResult = { text: "", confidence: 0 };
    for (let angle of [0, 90, 180, 270]) {
      const rotatedImage = await rotateImage(imageUrl, angle);
      const result = await Tesseract.recognize(rotatedImage, "eng");
      const { text, confidence } = result.data;
      if (confidence > bestResult.confidence) {
        bestResult = { text, confidence };
      }
    }
    return bestResult.text;
  };

  const processWithGPT = async (frontText, backText) => {
    const combinedText = `${frontText}\n${backText}`.trim();
    if (!combinedText) return;

    setLoading(true);
    const structured = await askChatGPT(combinedText);
    setParsedData(structured);
    setLoading(false);
  };

  // Safe JSON parse
  const parseJSONFromText = (text) => {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch {
      const match = text.match(/\{[\s\S]*\}/);
      if (match) {
        try {
          return JSON.parse(match[0]);
        } catch {
          return null;
        }
      }
    }
    return null;
  };

  // Send OCR to GPT
  const askChatGPT = async (ocrText) => {
    const prompt = `
Extract business card details from the following text.
Return only valid JSON in this format:

{
  "company": "",
  "name": "",
  "designation": "",
  "phone": "",
  "email": "",
  "address": "",
  "website": ""
}

Text:
${ocrText}`.trim();

    try {
      const response = await fetch(gptApiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Content: prompt }),
      });
      if (!response.ok) {
        throw new Error(`ChatGPT API failed: ${response.status}`);
      }

      const data = await response.json();
      //console.log(data);
      const candidateText =
        data?.choices?.[0]?.message?.content ||
        data?.reply ||
        data?.result ||
        data?.response ||
        (typeof data === "string" ? data : JSON.stringify(data));

      return parseJSONFromText(candidateText);
      // } catch (err) {
      //   //console.error("ChatGPT API error:", err);
      //   setError("Failed to fetch from ChatGPT API");
      //   return null;
      // }
    } catch (err) {
      console.error("ChatGPT API error:", err);

      setError(
        "Unable to extract card details. Please fill the fields manually.",
      );

      return {
        company: "",
        name: "",
        designation: "",
        phone: "",
        email: "",
        address: "",
        website: "",
      };
    }
  };

  // Upload handler (front or back)
  const handleFileUpload = (event, side) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      if (side === "front") setFrontPreview(imageUrl);
      else setBackPreview(imageUrl);

      setParsedData(null);
      setError(null);
      setLoading(true);

      (async () => {
        const ocrText = await runOCR(imageUrl);
        if (side === "front") {
          setFrontOCR(ocrText);
          await processWithGPT(ocrText, backOCR);
        } else {
          setBackOCR(ocrText);
          await processWithGPT(frontOCR, ocrText);
        }
      })();
    }
  };

  // Reset (front or back)
  const handleClear = (side) => {
    if (side === "front") {
      setFrontPreview(null);
      setFrontOCR("");
    } else {
      setBackPreview(null);
      setBackOCR("");
    }
    setParsedData(null);
    setError(null);
    setLoading(false);
  };

  return (
    <Box sx={{ p: 4, bgcolor: "#f5f7fa", minHeight: "100vh" }}>
      <Box display="flex" mb={2}>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/DashboardFinal")}
        >
          Back to Home
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Typography
        variant="h5"
        align="center"
        sx={{ fontWeight: "bold", mb: 3 }}
      >
        Business Card Scan (Front & Back)
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Left: Upload & Preview (Front + Back) */}
        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: 3,
            minWidth: 350,
            maxWidth: 450,
            textAlign: "center",
          }}
        >
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
            Upload Card Images
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* Front Side */}
            <Box sx={{ position: "relative" }}>
              {frontPreview && (
                <IconButton
                  size="small"
                  color="error"
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    bgcolor: "white",
                    borderRadius: "50%",
                    boxShadow: 1,
                    "&:hover": { bgcolor: "#f8d7da" },
                  }}
                  onClick={() => handleClear("front")}
                >
                  <CloseOutlinedIcon fontSize="small" />
                </IconButton>
              )}

              {loading && !frontPreview ? (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={180}
                  sx={{ borderRadius: 2 }}
                />
              ) : frontPreview ? (
                <img
                  src={frontPreview}
                  alt="Front Side"
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  }}
                />
              ) : (
                <label
                  htmlFor="upload-front"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    borderRadius: 12,
                    height: 180,
                    cursor: "pointer",
                  }}
                >
                  <CloudUpload style={{ fontSize: 40, color: "#666" }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload Front Side
                  </Typography>
                  <input
                    id="upload-front"
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => handleFileUpload(e, "front")}
                  />
                </label>
              )}
            </Box>

            {/* Back Side */}
            <Box sx={{ position: "relative" }}>
              {backPreview && (
                <IconButton
                  size="small"
                  color="error"
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    bgcolor: "white",
                    borderRadius: "50%",
                    boxShadow: 1,
                    "&:hover": { bgcolor: "#f8d7da" },
                  }}
                  onClick={() => handleClear("back")}
                >
                  <CloseOutlinedIcon fontSize="small" />
                </IconButton>
              )}

              {loading && !backPreview ? (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={180}
                  sx={{ borderRadius: 2 }}
                />
              ) : backPreview ? (
                <img
                  src={backPreview}
                  alt="Back Side"
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  }}
                />
              ) : (
                <label
                  htmlFor="upload-back"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    borderRadius: 12,
                    height: 180,
                    cursor: "pointer",
                  }}
                >
                  <CloudUpload style={{ fontSize: 40, color: "#666" }} />
                  <Typography variant="body2" color="text.secondary">
                    Upload Back Side
                  </Typography>
                  <input
                    id="upload-back"
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => handleFileUpload(e, "back")}
                  />
                </label>
              )}
            </Box>
          </Box>
        </Paper>

        {/* Right: Parsed Data 
        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: 3,
            minWidth: 500,
            maxWidth: 500,
            minHeight: 300,
          }}
        >
          {loading ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Skeleton variant="text" width="80%" height={40} />
              <Skeleton variant="text" width="60%" height={40} />
              <Skeleton variant="text" width="70%" height={40} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
            </Box>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : parsedData ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Event</InputLabel>

                  <Select
                    value={selectedEvent}
                    label="Event"
                    onChange={(e) => setSelectedEvent(e.target.value)}
                  >
                    {events.map((event) => (
                      <MenuItem key={event.eventId} value={event.eventId}>
                        {event.eventName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Company"
                  inputRef={txtCompany}
                  value={parsedData.company || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, company: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Address"
                  inputRef={txtAddress}
                  value={parsedData.address || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, address: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Name"
                  inputRef={txtName}
                  value={parsedData.name || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, name: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Designation"
                  inputRef={txtDesignation}
                  value={parsedData.designation || ""}
                  onChange={(e) =>
                    setParsedData({
                      ...parsedData,
                      designation: e.target.value,
                    })
                  }
                  fullWidth
                />
                <TextField
                  label="Contact No"
                  inputRef={txtContact}
                  value={parsedData.phone || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, phone: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Email"
                  inputRef={txtEmail}
                  value={parsedData.email || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, email: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Website"
                  inputRef={txtWebsite}
                  value={parsedData.website || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, website: e.target.value })
                  }
                  fullWidth
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClick}
                >
                  Save
                </Button>
              </Box>
            </motion.div>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Card Data
            </Typography>
          )}
        </Paper>
        */}

        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: 3,
            minWidth: 500,
            maxWidth: 500,
            minHeight: 300,
          }}
        >
          {/* Always show Event dropdown */}
          {/* <FormControl fullWidth sx={{ mb: 2 }}>
    <InputLabel>Event</InputLabel>
    <Select
      value={selectedEvent}
      label="Event"
      onChange={(e) => setSelectedEvent(e.target.value)}
    >
      {events.map((event) => (
        <MenuItem key={event.eventId} value={event.eventId}>
          {event.eventName}
        </MenuItem>
      ))}
    </Select>
  </FormControl> */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Event</InputLabel>

              <Select
                value={selectedEvent}
                label="Event"
                onChange={(e) => setSelectedEvent(e.target.value)}
              >
                {events.map((event) => (
                  <MenuItem key={event.eventId} value={event.eventId}>
                    {event.eventName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              onClick={() => setOpenEvent(true)}
              sx={{
                minWidth: 56,
                height: 56,
              }}
            >
              <AddIcon />
            </Button>
          </Box>

          {/* Private User Dropdown */}
          {/* {userType === "Private" && (
            <Autocomplete
              multiple
              fullWidth
              options={employeeList}
              value={selectedEmployees}
              onChange={(event, newValue) => {
                setSelectedEmployees(newValue);
              }}
              getOptionLabel={(option) =>
                `${option.empName} (${option.empEmail})`
              }
              isOptionEqualToValue={(option, value) =>
                option.empEmail === value.empEmail
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Private Users"
                  placeholder="Select Employees"
                />
              )}
              sx={{ mb: 2 }}
            />
          )} */}

          {userType === "Private" && (
            <Autocomplete
              multiple
              fullWidth
              options={employeeList}
              value={selectedEmployees}
              onChange={(event, newValue) => {
                setSelectedEmployees(newValue);
              }}
              getOptionLabel={(option) => option.empName}
              isOptionEqualToValue={(option, value) =>
                option.empNo === value.empNo
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Private Users"
                  placeholder="Select Employees"
                />
              )}
              sx={{ mb: 2 }}
            />
          )}

          {loading ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Skeleton variant="text" width="80%" height={40} />
              <Skeleton variant="text" width="60%" height={40} />
              <Skeleton variant="text" width="70%" height={40} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
              <Skeleton variant="rectangular" width="100%" height={50} />
            </Box>
          ) : parsedData ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {error && <Alert severity="warning">{error}</Alert>}

                <TextField
                  label="Company *"
                  inputRef={txtCompany}
                  value={parsedData.company || ""}
                  onChange={(e) => {
                    setParsedData({ ...parsedData, company: e.target.value });

                    if (e.target.value.trim()) {
                      setFieldErrors((prev) => ({
                        ...prev,
                        company: "",
                      }));
                    }
                  }}
                  error={!!fieldErrors.company}
                  helperText={fieldErrors.company}
                  fullWidth
                />

                <TextField
                  label="Address"
                  inputRef={txtAddress}
                  value={parsedData.address || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, address: e.target.value })
                  }
                  fullWidth
                />

                <TextField
                  label="Name *"
                  inputRef={txtName}
                  value={parsedData.name || ""}
                  onChange={(e) => {
                    setParsedData({ ...parsedData, name: e.target.value });

                    if (e.target.value.trim()) {
                      setFieldErrors((prev) => ({
                        ...prev,
                        name: "",
                      }));
                    }
                  }}
                  error={!!fieldErrors.name}
                  helperText={fieldErrors.name}
                  fullWidth
                />

                <TextField
                  label="Designation"
                  inputRef={txtDesignation}
                  value={parsedData.designation || ""}
                  onChange={(e) =>
                    setParsedData({
                      ...parsedData,
                      designation: e.target.value,
                    })
                  }
                  fullWidth
                />

                <TextField
                  label="Contact No *"
                  inputRef={txtContact}
                  value={parsedData.phone || ""}
                  onChange={(e) => {
                    setParsedData({ ...parsedData, phone: e.target.value });

                    if (e.target.value.trim()) {
                      setFieldErrors((prev) => ({
                        ...prev,
                        contact: "",
                      }));
                    }
                  }}
                  error={!!fieldErrors.contact}
                  helperText={fieldErrors.contact}
                  fullWidth
                />

                <TextField
                  label="Email *"
                  inputRef={txtEmail}
                  value={parsedData.email || ""}
                  onChange={(e) => {
                    setParsedData({ ...parsedData, email: e.target.value });

                    if (e.target.value.trim()) {
                      setFieldErrors((prev) => ({
                        ...prev,
                        email: "",
                      }));
                    }
                  }}
                  error={!!fieldErrors.email}
                  helperText={fieldErrors.email}
                  fullWidth
                />

                <TextField
                  label="Website"
                  inputRef={txtWebsite}
                  value={parsedData.website || ""}
                  onChange={(e) =>
                    setParsedData({ ...parsedData, website: e.target.value })
                  }
                  fullWidth
                />

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClick}
                >
                  Save
                </Button>
              </Box>
            </motion.div>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Upload a business card to view the details.
            </Typography>
          )}
        </Paper>
      </Box>

      {/* ===== Add Event Modal HERE ===== */}

      <Modal open={openEvent} onClose={() => setOpenEvent(false)}>
        <Box
          sx={{
            p: 3,
            bgcolor: "#fff",
            m: "auto",
            mt: 10,
            width: 400,
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" mb={2}>
            Add Event
          </Typography>

          <form onSubmit={handleEventSubmit}>
            <TextField
              label="Event Name"
              fullWidth
              value={form.name}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
              onBlur={handleBlur}
            />

            <Box mt={2} textAlign="right">
              <Button
                onClick={() => {
                  setOpenEvent(false);

                  setForm({
                    id: "0",
                    name: "",
                  });
                }}
              >
                Cancel
              </Button>

              <Button type="submit" variant="contained">
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </Box>
  );
}
